// utils/computeLapHistory.js
/**
 * participants = [
 *   { number: 'bib', lapTimes: [{ lap, cumulative } …] }
 * ]
 * Devuelve un objeto con lap, acumulados, posiciones y cambios
 */
const toSec = t =>
  typeof t === 'string'
    ? t.split(':').reverse()
        .reduce((s,v,i)=> s + parseFloat(v||0) * 60**i , 0)
    : Number(t||0);

export default function computeLapHistory(participants = [], totalLaps = 0) {
  const hist = {};                     // { [bib]: { lap,cumul,pos,chg } }

  for (let lap = 0; lap < totalLaps; lap++) {
    const orden = participants
      .filter(p => p.lapTimes?.[lap]?.cumulative)
      .sort((a,b)=> toSec(a.lapTimes[lap].cumulative) -
                    toSec(b.lapTimes[lap].cumulative));

    orden.forEach((ath, idx) => {
      const num = String(ath.number);
      if (!hist[num]) {
        hist[num] = {
          lap : Array(totalLaps).fill(null),
          cumul  : Array(totalLaps).fill(null),
          pos    : Array(totalLaps).fill(null),
          chg    : Array(totalLaps).fill(null)
        };
      }
      hist[num].lap[lap] = ath.lapTimes[lap].lap;
      hist[num].cumul[lap] = ath.lapTimes[lap].cumulative;
      hist[num].pos[lap] = idx + 1;

      if (lap > 0 && hist[num].pos[lap-1]) {
        const diff = hist[num].pos[lap-1] - (idx+1);
        hist[num].chg[lap] = diff === 0 ? null
                          : diff  > 0 ? {dir:'up',   val: diff}
                                      : {dir:'down', val:-diff};
      }
    });
  }
  return hist;
}
